<template>
  <div class="content-wrapper">
    <div class="vx-col">
      <div class="w-full flex flex-wrap item-center mb-base mt-2">
        <vs-chip v-if="!activeWorkspace.service" color="#666666" style="margin-right:10px;">종강</vs-chip>
        <h2 class="text-primary" style="width:450px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;"> {{activeWorkspace.title}} </h2>
      </div>

        <vs-divider color="#d5d5d5"></vs-divider>
          <div class="vx-row justify-end">
            <ul class="con-s" style="margin-top:3px; margin-right:10px;">
              <li>
                <vs-switch color="success" v-model="serviceVal" :disabled="activeUserLevel < 3">
                  <span slot="on">개강</span>
                  <span slot="off">종강</span>
                </vs-switch>
              </li>
            </ul>
          <vs-button v-if="activeUserLevel >= 3" icon-pack="feather" icon="icon-upload" type="flat" style="margin-left:8px; margin-right:8px; margin-bottom:5px;" color="dark" size="small" @click="saveWorksacpeInfo()">저장</vs-button>
        </div>
      </div>

    <div class="flex flex-wrap vx-col w-full item-center">
        <vs-alert active="true" class="mt-2 cursor-pointer" icon-pack="feather" icon="icon-alert-circle" style="margin-bottom:5px;" @click="openNotice()">
          {{lastNotice.title}}
        </vs-alert>
    </div> <br>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4" style="margin-bottom:25px;">
          <statistics-card-line
            hideChart
            icon="UserIcon"
            icon-right
            :statistic="memberVal"
            statisticTitle="총 팀원수" />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4" style="margin-bottom:25px;">
          <statistics-card-line
            hideChart
            icon="ServerIcon"
            icon-right
            :statistic="projecVal"
            statisticTitle="총 프로젝트수"
            color="success" />
      </div>
    </div>
    <div id="tag1" class="vx-row" >
      <div class="vx-col w-full" style="margin-top:3px; margin-bottom:25px;" >
      <vx-card>
        <input-tag v-model="tags" placeholder="연관되는 단어를 태그해보세요."  :read-only="activeUserLevel < 3 || !activeWorkspace.service" style="border:none;"/>
      </vx-card>
      </div>
    </div>
    <div  v-if="activeUserLevel >= 3 && activeWorkspace.service"  class="vx-row">
      <div class="vx-col w-full">
       <vx-card>
         <quill-editor v-model="content"  :options="editorOption"/>
        <!-- <quill-editor v-model="content" :options="editorOption">
          <div id="toolbar" slot="toolbar">
            <button class="ql-bold">Bold</button>
            <button class="ql-italic">Italic</button>
            <select class="ql-size">
              <option value="small"></option>
              <option selected></option>
              <option value="large"></option>
              <option value="huge"></option>
            </select>
            <select class="ql-font">
              <option selected="selected"></option>
              <option value="serif"></option>
              <option value="monospace"></option>
            </select>
            <button class="ql-image"></button>
            <button class="ql-video"></button>
            </div>
          </quill-editor> -->
         </vx-card>
        </div>
    </div>
    <div v-if="activeUserLevel < 3 || !activeWorkspace.service" class="vx-col w-full">
      <vx-card>
        <div class="output ql-snow">
          <div class="ql-editor" v-html="activeWorkspace.detail"></div>
        </div>
      </vx-card>
    </div>
</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import InputTag from 'vue-input-tag'
import Quill from 'quill'
import {
  ImageDrop
} from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)


export default {
  components: {
      VueApexCharts,
      StatisticsCardLine,
      ChangeTimeDurationDropdown,
      quillEditor,
      'input-tag': InputTag,
  },
  // watch: {
  //   tags(){
  //     if(!this.activeWorkspace.tags){
  //       this.$store.dispatch('space/updateWorkspaceTags', {id:this.activeWorkspace.id, tags:this.tags})
  //     } else{
  //       if (this.tags.length == this.activeWorkspace.tags.length){
  //         for(var index in this.activeWorkspace.tags){
  //           if (this.activeWorkspace.tags[index] != this.tags[index]){
  //             this.$store.dispatch('space/updateWorkspaceTags', {id:this.activeWorkspace.id, tags:this.tags})
  //           }
  //         }
  //       } else{
  //         this.$store.dispatch('space/updateWorkspaceTags', {id:this.activeWorkspace.id, tags:this.tags})
  //       }
  //     }
  //   }
  // },
  computed: {
    lastNotice() {
      if(this.$store.state.notice.ActiveNotice) {
        return this.$store.state.notice.ActiveNotice
      }
      return  { title:'공지사항 없음', detail:'detail', id:0 }
    },
    activeWorkspace() {
      return this.$store.state.space.ActiveSpaceInfo
    },
    activeUserLevel() {
      return this.$store.state.space.ActiveDashBoardLevel
    },
    memberVal() {
      return this.$store.state.space.workspaceMembers.length +"명"
    },
    projecVal() {
      return this.$store.state.project.projects.length+"개"
    }
  },
  data() {
    return{
      serviceVal: false,
      tags: ["필드유"],
      // editorOption: {
      //   modules: {
      //     toolbar: '#toolbar'
      //   }
      // },
      content: '',
      activeUsers: {},
      editorOption: {
        modules: {
          imageDrop: true,
          imageResize: true,
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{
              'header': 1
            }, {
              'header': 2
            }],
            [{
              'list': 'ordered'
            }, {
              'list': 'bullet'
            }],
            [{
              'script': 'sub'
            }, {
              'script': 'super'
            }],
            [{
              'indent': '-1'
            }, {
              'indent': '+1'
            }],
            [{
              'direction': 'rtl'
            }],
            [{
              'size': ['small', false, 'large', 'huge']
            }],
            [{
              'header': [1, 2, 3, 4, 5, 6, false]
            }],
            [{
              'font': []
            }],
            [{
              'color': []
            }, {
              'background': []
            }],
            [{
              'align': []
            }],
            ['clean'],
            ['link', 'image', 'video']
          ],
        },
        theme: 'snow'
      },
      }
    },
    created(){
      if(this.$route.params.spaceId == 0){
        this.$route.params.spaceId = this.$store.state.space.ActiveSpaceInfo.id
      }
      this.$store.dispatch('space/getWorkspace', this.$route.params.spaceId).then(()=>{
        this.content = this.activeWorkspace.detail
        if(this.activeWorkspace.tags){
          this.tags = this.activeWorkspace.tags
        }
        this.serviceVal = this.activeWorkspace.service
      })
    },
    methods: {
      // blurTags(){
      //   if (this.activeWorkspace.detail != this.content){
      //     this.$store.dispatch('space/updateWorkspaceDetail', {id:this.activeWorkspace.id, detail:this.content})
      //   }
      // },
      saveWorksacpeInfo(){
        this.$store.dispatch('space/updateWorkspace', {id:this.activeWorkspace.id, title:this.activeWorkspace.title, tags:this.tags,
        detail:this.content, service:this.serviceVal}).then(()=>{
          this.$vs.notify({
            color: 'success',
            title: '수정 완료'
          })
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '에러',
            text: '관리자에게 문의해 주세요.'
          })
        })
      },
      acceptAlert() {
        this.$router.push('/apps/space')
      },
      openNotice() {
        if(this.$store.state.notice.ActiveNotice) {
          this.$router.push('/apps/space/dashboard/notice/' + 'open')
        }
      }
    }
}
</script>
<style lang="scss">
#demo-card-analytics {
    .tasks-today-container {
        .tasks-today__task {
            transition: background .15s ease-out;
            .tasks-today__actions {
                display: none;
            }
            &:hover {
                background: rgba(var(--vs-primary),.04) ;
                .tasks-today__actions {
                    display: flex;
                }
            }
        }
    }
}
.tag1{
  border:none;
}
</style>
